export default __webpack_public_path__ + "static/media/LLP_1.95a2ec15.png";